module.exports = {"LOGIN_URL":"https://permission.1sapp.com","PROJECT_SCHEMA":"ewx-project","TOKEN_SCHEMA":"ewx-perm-token","QA_SCHEMA":"ewx-qa","TOKEN_EXPIRES":100,"API_URL":"https://api-perm.1sapp.com","TEST_API_URL":"http://test-api.qukan.perm.aimodou.net"}


//////////////////
// WEBPACK FOOTER
// ./~/@qtt/ewx-login-sdk/config.json
// module id = 245
// module chunks = 16